import {
    /** FETCH APPLICATION  */
    FETCH_SIGNMSS_FULFILLED,
    FETCH_SIGNMSS_REJECTED,
    FETCH_SIGNMSS_PENDING,
    RESET_SIGNMSS,
} from "../../actions/agreement/signMSS";
const initialState = {
    done: false,
    error: false,
    spinner: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_SIGNMSS_PENDING:
            return {
                done: false,
                error: false,
                spinner: true
            };
        case FETCH_SIGNMSS_FULFILLED:
            return {
                ...state,
                signMSS: action.payload,
                done: true,
                error: false,
                spinner: false
            };
        case FETCH_SIGNMSS_REJECTED:
            return {
                ...state,
                error: action.payload,
                done: false,
                spinner: false
            };
        case RESET_SIGNMSS:
            return {
                initialState,
                done: false,
                error: false,
                spinner: false
            };
        default:
            return state;
    }
};